module.exports = __webpack_public_path__ + "static/img/mutantVX.79ed2b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MutantVx/assets/mutantVX.png
// module id = qmgD
// module chunks = 1